// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b55247ae","scoped":false,"hasInlineConfig":false}!./src/modules/storekeepers_stocks/views/print/FreightPrintStockNote.css
// module id = 767
// module chunks = 0